import React from 'react'
import { Checkbox } from 'react-bootstrap'

const C = ({
  disabled,
  required,
  onChange,
  style,
  checked,
  label
}) => 
  <Checkbox
    style={style}
    required={required}
    disabled={disabled}
    checked={checked}
    onChange={(e)=>onChange(e)}
  >
    {label}
  </Checkbox>


export default C


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Checkbox.js